import React from "react";
import { Alert, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import { dashboard2ScheduleLoadErrorAlertSx } from "../dashboard2-status.styles";

type Dashboard2ScheduleLoadErrorBannerProps = {
  onRetry: () => void;
};

export const Dashboard2ScheduleLoadErrorBanner: React.FC<
  Dashboard2ScheduleLoadErrorBannerProps
> = ({ onRetry }) => {
  const { t } = useTranslation();

  return (
    <Alert
      severity="error"
      variant="outlined"
      role="alert"
      sx={dashboard2ScheduleLoadErrorAlertSx}
      data-testid="dashboard2-schedule-load-error"
      action={
        <Button color="inherit" size="small" onClick={onRetry}>
          {t("_dashboard2_scheduleLoadRetry")}
        </Button>
      }
    >
      {t("_dashboard2_scheduleLoadError")}
    </Alert>
  );
};
